import {v4 as uuidv4} from "uuid";
import {getLastReferences, getLastUserMessage, getReferenceDifferences} from "../../../misc/messageMetadataUtils.ts";
import messageIdMapping from "../../../IdMappings/MessageIdMapping.ts";
import {resizeImage} from "../../../uploadUtils/image/ImageUtils.ts";
import {uploadMedia} from "../../../uploadUtils/helpers/simpleMediaUpload.ts";

export const formatPageContentsMessages = async (url: string, pageText: string, screenshot: string, currentMessageRef: any, llmRequestRefs: any, contextMode: string, isIncognito: boolean, user: any) => {
    let pageContentsMessage;
    let truncatedPageContentsMessage;
    const currentRefVals = [];
    currentRefVals.push({ path: url, type: 'url' });
    const lastUserMessage = getLastUserMessage(currentMessageRef);

    if (contextMode === "Image Only" || contextMode === "Text + Image") {
        const image = new Image();
        image.src = screenshot;
        await new Promise((resolve) => {
            image.onload = resolve;
        });
        const resizedImageContent = await resizeImage('image/png', image);

        const imageName = uuidv4();
        llmRequestRefs.current.mediaWritePromises[imageName] = uploadMedia(isIncognito, user, resizedImageContent, 'image/png');
        const newContent = [
            {
                fileName: imageName,
                fileType: 'image/png',
                fileSize: null,
                fileContent: resizedImageContent,
                type: 'image',
                removeOnRegenerate: true,
                storeAfterUse: true
            },
            ...lastUserMessage.message.content
        ];
        lastUserMessage.message = {
            ...lastUserMessage.message,
            content: newContent,
        };

    }

    const lastReferences = getLastReferences(messageIdMapping[lastUserMessage.parent]);
    const [onlyInLast, onlyInCurrent] = getReferenceDifferences(lastReferences, currentRefVals);

    if (onlyInCurrent.length !== 0 || onlyInLast.length !== 0) {
        lastUserMessage.metadata.referenceChanges = {added: onlyInCurrent, removed: onlyInLast};
    }
    lastUserMessage.metadata.references = currentRefVals;
    pageContentsMessage = `I am currently viewing the page: ${url}.`;
    truncatedPageContentsMessage = `I am currently viewing the page: ${url}.`;

    if (contextMode === "Text only" || contextMode === "Text + Image") {
        pageContentsMessage += `\nHere is the text of the page:\n"""\n${pageText}\n"""`;
        truncatedPageContentsMessage += `\nHere is the text of the page:\n"""\n<Truncated for brevity>\n"""`;
    }

    return {original: pageContentsMessage, truncated: truncatedPageContentsMessage};
};

